import { inject, Injectable } from '@angular/core';
import { SurveyCreationActionsFacade } from '../../state/survey-creation.actions.facade';

@Injectable()
export abstract class LocationActionDispatchBase {
  protected readonly _surveyCreationActionsFacade = inject(
    SurveyCreationActionsFacade,
  );

  public uploadLocationCodes(
    countryCode: string,
    surveyId: number,
    qualificationCode: number,
    qualificationName: string,
    file: File,
  ): void {
    this._surveyCreationActionsFacade.uploadLocationCodes(
      countryCode,
      surveyId,
      qualificationCode,
      qualificationName,
      file,
    );
  }

  public clearLocationCodes(
    qualificationCode: number,
    qualificationName: string,
  ): void {
    this._surveyCreationActionsFacade.clearLocationCodes(
      qualificationCode,
      qualificationName,
    );
  }

  public downloadLocationCodesTemplate(
    countryCode: string,
    qualificationCode: number,
  ): void {
    this._surveyCreationActionsFacade.downloadLocationCodesTemplate(
      countryCode,
      qualificationCode,
    );
  }

  public downloadValidatedLocationFile(qualificationCode: number): void {
    this._surveyCreationActionsFacade.downloadValidatedLocationFile(
      qualificationCode,
    );
  }
}
